import { BrandLogo } from "@/components/brand-logo";
import {
  PARENT_BRAND_LOGO_SRC,
  PARENT_BRAND_NAME,
  PARENT_BRAND_URL,
  PRODUCT_NAME,
} from "@/lib/brand";
import { isDesktopShell } from "@/lib/desktop-shell";
import { Link } from "react-router-dom";

export function SiteFooter() {
  const desktop = isDesktopShell();
  return (
    <footer className="border-t border-white/50 bg-white/40 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[90rem] flex-col gap-6 px-4 py-10 md:flex-row md:items-center md:justify-between md:px-8 xl:px-10">
        <div>
          <BrandLogo href={desktop ? "/login" : "/"} size={32} />
          <p className="mt-3 max-w-sm text-sm text-slate-600">
            Mortgage broker helpers for Velocity, follow-ups, bookings, and
            approvals — so you spend time with clients, not your inbox.
          </p>
        </div>
        <nav className="flex flex-wrap gap-4 text-sm font-medium text-slate-600" aria-label="Footer">
          {desktop ? null : (
            <>
              <Link to="/#product" className="hover:text-teal-800">
                Product
              </Link>
              <Link to="/#how-it-works" className="hover:text-teal-800">
                How it works
              </Link>
              <Link to="/#screens" className="hover:text-teal-800">
                Screens
              </Link>
              <Link to="/pricing" className="hover:text-teal-800">
                Pricing
              </Link>
            </>
          )}
          <Link to="/signup" className="hover:text-teal-800">
            Sign up
          </Link>
          <Link to="/terms" className="hover:text-teal-800">
            Terms
          </Link>
          <Link to="/privacy" className="hover:text-teal-800">
            Privacy
          </Link>
        </nav>
      </div>
      <div className="flex flex-col items-center gap-2 border-t border-white/40 px-4 py-4 text-center text-xs text-slate-500 sm:flex-row sm:justify-center sm:gap-3">
        <span>
          © {new Date().getFullYear()} {PRODUCT_NAME}. A {PARENT_BRAND_NAME}{" "}
          property.
        </span>
        <a
          href={PARENT_BRAND_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center rounded-md opacity-90 transition-opacity hover:opacity-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-700"
        >
          <img
            src={PARENT_BRAND_LOGO_SRC}
            alt={PARENT_BRAND_NAME}
            width={140}
            height={27}
            className="h-5 w-auto"
          />
        </a>
      </div>
    </footer>
  );
}
